import React from 'react'
import { Link, useNavigate } from 'react-router-dom'
import { FiArrowRight, FiShield } from 'react-icons/fi'
import './footer.css'

const COLUMNS = [
  {
    heading: 'Company',
    links: [['/', 'home'], ['/about', 'about us'], ['/team', 'team'], ['/faq', 'faqs'], ['/privacy-policy', 'privacy policy']],
  },
  {
    heading: 'Markets',
    links: [['/forex', 'forex'], ['/indices', 'indices'], ['/stocks', 'stocks'], ['/futures', 'futures'],
            ['/commodities', 'commodities'], ['/bonds', 'bonds'], ['/options', 'options']],
  },
  {
    heading: 'Analytics',
    links: [['/news', 'market news'], ['/technical-analysis', 'technical analysis'], ['/heatmaps', 'heatmaps'], ['/watchlists', 'watchlists']],
  },
]

const Footer = () => {
  const navigate = useNavigate()

  return (
    <footer className='footer'>
      {/* closing call to action */}
      <div className="footer-cta" data-aos="fade-up">
        <div>
          <h2 className="footer-cta-title">Ready to mirror the experts?</h2>
          <p className="footer-cta-text">Create your account in minutes and let seasoned traders put your capital to work.</p>
        </div>
        <button className="footer-cta-btn" onClick={() => navigate('/signup')}>
          Get started <FiArrowRight />
        </button>
      </div>

      <div className="trusted-patners-section">
        <h2>Our partners</h2>
        <div className="trusted-patners-img-container">
          {['a', 'b', 'c', 'd', 'e'].map(letter => (
            <img key={letter} src={`/${letter}-xs-light.png`} alt="" className="trusted-patener-icon" />
          ))}
        </div>
      </div>

      <div className="quicklinks-container">
        <div className="quicklink-card-container">
          <div className="quicklink-card footer-brand-col">
            <Link to="/" aria-label="Ollarin Mirror home">
              <img src="/ollarinmirror-logo.svg" alt="Ollarin Mirror" className="footer-logo" />
            </Link>
            <p className="footer-brand-desc">Professional copy trading platform connecting investors with expert traders across global financial markets.</p>
            <p className="footer-address">Keizersgracht 555, 1017 DR Amsterdam, Netherlands</p>
            <a href="mailto:ollarinmirror@gmail.com" className="footer-email">ollarinmirror@gmail.com</a>
          </div>
          {COLUMNS.map(column => (
            <div className="quicklink-card" key={column.heading}>
              <span className="footer-col-heading">{column.heading}</span>
              {column.links.map(([to, label]) => <Link key={to} to={to}>{label}</Link>)}
            </div>
          ))}
        </div>

        <div className="copyright-container">
          <div className="copyright-txt">
            <p>&copy; {new Date().getFullYear()} Ollarin Mirror. All rights reserved.</p>
          </div>
          <div className="footer-security">
            <FiShield /> Accounts protected with two-factor authentication
          </div>
          <div className="policy-txt">
            <Link to="/privacy-policy">Privacy &amp; terms</Link>
            <a href="/licence-agreement.docx" download="Ollarin-Mirror-Licence-Agreement-Demo.docx">Licence agreement</a>
          </div>
        </div>
      </div>
    </footer>
  )
}

export default Footer
